export const classes = {
  rows: 'flex flex-col gap-[9px]',
  row: 'place-between text-[13px]',
  rowLabel: 'text-taupe-2 dark:text-mauve-2',
  rowValue: 'font-semibold text-taupe-3 dark:text-mauve-1',
  vatNote: 'text-taupe-2 dark:text-mauve-2',
  free: 'font-bold text-pos dark:text-pos-dark',
  rule: 'my-[5px] h-px bg-hair dark:bg-hair-dark',
  totalRow: 'flex items-baseline justify-between',
  totalLabel: 'text-sm font-bold text-taupe-3 dark:text-mauve-1',
  totalValue:
    'font-extrabold tracking-[-0.02em] text-taupe-3 dark:text-mauve-1',
  totalMd: 'text-[22px]',
  totalLg: 'text-2xl',
};
